import React, { useEffect } from "react";
import { Form, Input, Button, Row, Col, Spin, DatePicker } from "antd";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";

import { DATE_FORMAT_FRONTEND, DATE_FORMAT_QUERY } from "../../../constants";
import { getTranslation } from "../../../utils/helper";
import dayjs from "dayjs";

const MessageLogsFilterForm = ({ isFetching, query, onSubmit }) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;

  const [form] = Form.useForm();

  const dateField = "deliveryDate";
  const dateValue = query[dateField];

  const routePlanField = "routePlan";
  const routePlanValue = query[routePlanField];

  const fromField = "from";
  const fromValue = query[fromField];

  const toField = "to";
  const toValue = query[toField];

  useEffect(() => {
    form.setFieldsValue(initialValues());
  }, [query]);

  const initialValues = () => {
    const values = {};
    values[dateField] = dateValue ? dayjs(dateValue) : null;
    values[routePlanField] = routePlanValue;
    values[fromField] = fromValue;
    values[toField] = toValue;
    return values;
  };

  const handleSubmit = values => {
    const params = {};
    params[dateField] = (values[dateField] && values[dateField]).format(DATE_FORMAT_QUERY) || null;
    params[routePlanField] = values[routePlanField] || null;
    params[fromField] = values[fromField] || null;
    params[toField] = values[toField] || null;
    onSubmit({ ...query, ...params }, true);
  };

  const handleResetButton = () => {
    onSubmit({}, true);
    form.resetFields();
  };

  return (
    <Spin spinning={isFetching}>
      <Form
        form={form}
        onFinish={handleSubmit}
        initialValues={initialValues}
        className="FilterForm MessageLogsFilterForm"
        layout="vertical">
        <div className="FilterFormContent">
          <Row gutter={16}>
            <Col xs={{ span: 24 }} md={{ span: 6 }}>
              <Form.Item label={getTranslation(setting, "Message Logs", "Date")} name={dateField}>
                <DatePicker
                  size="large"
                  format={DATE_FORMAT_FRONTEND}
                  placeholder={getTranslation(setting, "Message Logs", "Date")}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 6 }}>
              <Form.Item label={getTranslation(setting, "Message Logs", "Route Plan")} name={routePlanField}>
                <Input size="large" placeholder={getTranslation(setting, "Message Logs", "Route Plan")} />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 6 }}>
              <Form.Item label={getTranslation(setting, "Message Logs", "From")} name={fromField}>
                <Input size="large" placeholder={getTranslation(setting, "Message Logs", "From")} />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 6 }}>
              <Form.Item label={getTranslation(setting, "Message Logs", "To")} name={toField}>
                <Input size="large" placeholder={getTranslation(setting, "Message Logs", "To")} />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div className="FilterFormActions">
          <Button size="large" type="text" onClick={handleResetButton}>
            {getTranslation(setting, "Common", "Reset")}
            <ReactSVG className="icon" src="/icons/reset.svg" />
          </Button>
          <Button size="large" type="primary" htmlType="submit">
            {getTranslation(setting, "Common", "Apply")}
            <ReactSVG className="icon" src="/icons/apply.svg" />
          </Button>
        </div>
      </Form>
    </Spin>
  );
};

export default MessageLogsFilterForm;
